import React, { FC, Fragment } from 'react';
import { Grid, AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LoaderComponents, Loaders } from 'components';
import { times } from 'lodash';

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: theme.custom.bodyMaxWidth,
    marginTop: theme.spacing(3),
    margin: theme.custom.bodyMargin,
    padding: 12,
  },
}));

/**
 * Special loader for startup (cognito lookup) and initial queries
 * (bootstrap) before fixed header is rendered. The calc offset
 * prevents page jumping.
 */
const Startup: FC = () => {
  const { Content, Image } = LoaderComponents;
  const classes = useStyles();

  return (
    <Fragment>
      <AppBar>
        <Toolbar>
          <Grid container justify="space-between" wrap="nowrap">
            <Grid item>
              <Content height={20} maxWidth={300} />
            </Grid>
            <Grid container item spacing={2} justify="flex-end">
              <Grid item>
                <Image shape="circle" />
              </Grid>
              <Grid item>
                <Image shape="circle" />
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid container item direction="column" spacing={3} xs={12} md={3}>
            {times(8, rowIndex => (
              <Grid item key={rowIndex}>
                <Content index={rowIndex} height={15} maxWidth={200} />
              </Grid>
            ))}
          </Grid>
          <Grid item xs={12} md={5}>
            <Loaders.Feed />
          </Grid>
          <Grid item xs={12} md={4}>
            <Loaders.Widget />
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default Startup;
